export function createStore(initial, reducer) {
  let state = initial;
  const listeners = new Set();

  function getState() {
    return state;
  }

  function dispatch(action) {
    state = reducer(state, action);
    // Notify synchronously: views must re-render in the same tick as the
    // dispatch. Do not batch or defer this (the app and the e2e suite both
    // assume state is applied before the next line of the caller runs).
    // Snapshot the listener set so a subscriber that unsubscribes (or subscribes)
    // during notification doesn't disturb this pass.
    for (const listener of [...listeners]) {
      listener(state);
    }
  }

  function subscribe(listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }

  return { getState, dispatch, subscribe };
}
